<div class="ty-page-container">
  <span nz-icon nzType="check-circle" nzTheme="outline"></span>
  <h2 class="title-generic" *ngIf="selectedRoute === 'generic-consultation'">{{ 'steps.tyPage.titleGeneric' | translate }}</h2>
  <h2 *ngIf="selectedRoute !== 'generic-consultation'">{{ 'steps.tyPage.' + (isFromPayment ? isFromPayment.toLowerCase() : 'title') | translate }}</h2>  
  <p *ngIf="selectedRoute !== 'generic-consultation' && selectedRoute !== 'televisit-generic-booking'">{{ 'steps.tyPage.description' | translate }}</p>
  <p *ngIf="selectedRoute === 'televisit-generic-booking'">{{ 'steps.tyPage.description_televisit_generic' | translate }}</p>
  <ds-button text="{{ 'steps.tyPage.button' | translate }}" [width]="'small'" (click)="exit()"></ds-button>
</div>
